import React, { useState, useEffect, useCallback } from 'react';
import { node } from 'prop-types';
import { useFeatureFlags, useListingData, useGTM } from 'hooks';
import { ProductBooster } from 'modules';
import { InCategorySearchPreviews } from 'contexts';
import { inCategorySearchShape } from 'shapes';
import { CategoryProvider } from '../CategoryPage/components';
import { CategoryDetector } from './components';

const SearchPage = ({ categoryPreviews, children }) => {
    const [mainCategory, setMainCategory] = useState({ context: {} });
    const { listingData } = useListingData();
    const [, pushToGTM] = useGTM();

    const [{ hasSponsoredProducts }] = useFeatureFlags({
        hasSponsoredProducts: 'relevance.listing.sponsored.products',
    });

    const updateMainCategory = newMainCategory => {
        if (mainCategory.id !== newMainCategory.id) {
            setMainCategory(newMainCategory);
        }
    };

    const setSearchQueryIntoDataLayer = useCallback(() => {
        if (listingData && listingData.query) {
            pushToGTM({
                search_query: listingData.query,
            });
        }
    }, [pushToGTM, listingData.query]);

    useEffect(() => setSearchQueryIntoDataLayer(), []);

    return (
        <InCategorySearchPreviews
            attribute="categories.last_id"
            categoryPreviews={categoryPreviews}
        >
            <CategoryDetector onCategoryDetected={updateMainCategory} />
            <CategoryProvider category={mainCategory}>
                {children}
                {hasSponsoredProducts && <ProductBooster pageType="search" />}
            </CategoryProvider>
        </InCategorySearchPreviews>
    );
};

SearchPage.propTypes = {
    children: node.isRequired,
    categoryPreviews: inCategorySearchShape,
};

SearchPage.defaultProps = {
    categoryPreviews: [],
};

export default SearchPage;
